<template>
  <v-navigation-drawer
    :model-value="isSidebarShown"
    :rail="isMiniSidebarShown"
    rail-width="104"
    style="max-width: 256px"
    :permanent="isDesktop"
    class="bg-black sidebar-custom-scroll"
    touchless
    @update:model-value="setIsSidebarShown($event)"
  >
    <div class="px-5 pb-5">
      <menu-bar />
      <install-pwa v-if="pwaInstallIsShown" />
      <support-links class="mt-1" />
      <language-select v-if="getLocales.length" class="mt-4" />
    </div>
    <template v-if="adNetworkHasSectionCampaigns" #prepend>
      <div class="px-5 py-6">
        <c-btn
          :to="{ name: routeNames.CREATE_CAMPAIGN }"
          color="primary"
          :label="isMiniSidebarShown ? undefined : $t('main.create_campaign')"
          block
          x-large
          :icon-props="
            isMiniSidebarShown
              ? {
                  icon: ' $plus',
                  size: 24
                }
              : undefined
          "
          :height="42"
          class="text-subtitle-1 font-weight-bold overflow-hidden"
          @click="sendCreateCampaignGtmEvent()"
        />
      </div>
    </template>
    <template v-if="isDesktop" #append>
      <v-divider />
      <resizer-button />
    </template>
  </v-navigation-drawer>
</template>

<script>
  import { mapState, mapActions } from 'pinia'
  import MenuBar from '@/components/main/Sidebar/MenuBar.vue'
  import SupportLinks from '@/components/main/Sidebar/SupportLinks.vue'
  import ResizerButton from '@/components/main/Sidebar/ResizerButton.vue'
  import LanguageSelect from '@/components/main/Sidebar/LanguageSelect.vue'
  import InstallPwa from '@/components/main/Sidebar/installPwa.vue'
  import routeNames from '@/types/route-names'
  import guardSections from '@/types/guard-sections'
  import gtmPush from '@/services/utils/gtm-push'
  import { gtmEvents } from '@clickadilla/components/constants'
  import { useSettingsStore } from '@/store/settings/settings'
  import { CBtn } from '@clickadilla/components/components'

  export default {
    name: 'Sidebar',
    components: {
      LanguageSelect,
      MenuBar,
      SupportLinks,
      ResizerButton,
      InstallPwa,
      CBtn
    },
    data() {
      return {
        routeNames
      }
    },
    computed: {
      ...mapState(useSettingsStore, [
        'isMiniSidebarShown',
        'isSidebarShown',
        'pwaIsStarted',
        'adNetwork',
        'getLocales'
      ]),
      pwaInstallIsShown() {
        // :TODO vue3
        // return this.pwaIsStarted && this.$pwa.hasPrompt
        return false
      },
      adNetworkHasSectionCampaigns() {
        return this.adNetwork.guardSections.some(({ name }) => name === guardSections.CAMPAIGNS)
      },
      isDesktop() {
        return !this.$vuetify.display.mobile
      }
    },
    methods: {
      ...mapActions(useSettingsStore, ['setIsSidebarShown']),
      sendCreateCampaignGtmEvent() {
        gtmPush({ event: gtmEvents.SIDEBAR_CREATE_CAMPAIGN_BTN })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sidebar-custom-scroll {
    & ::-webkit-scrollbar {
      width: 5px;
    }

    & ::-webkit-scrollbar-track {
      background-color: rgb(var(--v-theme-secondary-800));
    }
    & ::-webkit-scrollbar-thumb {
      background-color: rgb(var(--v-theme-secondary-600));
      box-shadow: unset;
    }
  }

  :deep(.v-navigation-drawer__content) {
    scrollbar-gutter: stable;
  }
</style>
